import React, { FC } from 'react';

import { Alert, Button, Input, Select } from '@.ui';
import { createPreventDefault } from '@/Lib';
import { useLingualField } from '@/Services';
import { ProductProposal } from '@/Services/api/methods/ProductsProposals';
import { DictionaryItem } from '@/Types/api/Dictionaries';
import { ProductProposalsBrandStateEnum } from '@/Types/ProductProposals';

import S from './styles.module.scss';
import { useApproveProduct } from './useApproveProduct';

interface ApproveProductProposalModalProps {
    productProposal: ProductProposal;
    close: () => void;
    updateProductProposal: () => void;
    dictionaryValues?: DictionaryItem[];
}

export const ApproveProductProposalModal: FC<ApproveProductProposalModalProps> = ({ productProposal, updateProductProposal, close, dictionaryValues }) => {
    const { approve, isShowUpdatedProductProposalMessage, field } = useApproveProduct({
        productProposal,
        updateProductProposal,
        close,
    });

    const viewActualStateProductProposal = createPreventDefault(() => {
        updateProductProposal();
        close();
    });

    const productName = useLingualField(productProposal);

    return (
        <div className={S.modal}>
            <h1>Approve product {productName}</h1>

            {isShowUpdatedProductProposalMessage && (
                <div>
                    <p className={S.modal_error}>While you were checking and set UDI, the product application was updated</p>

                    <div className={S.modal__actions}>
                        <Button color="brown" onClick={viewActualStateProductProposal}>
                            View actual product proposal
                        </Button>
                    </div>
                </div>
            )}

            {!isShowUpdatedProductProposalMessage && (
                <>
                    <p className={S.modal_description}>For approve need set UDI for new product</p>

                    {productProposal.is_duplicating_product && <Alert className={S.alert}>Duplicating another product name</Alert>}

                    <div className={S.wrapper}>
                        <Input {...field('udi').register()} type="number" text="UDI" required />

                        {productProposal.brand_state !== ProductProposalsBrandStateEnum.FILLED && dictionaryValues && (
                            <>
                                <Select {...field('brand_id').register<number>()} label="Brand" placeholder="Search a product Brand" absolute required>
                                    {dictionaryValues.map((item) => (
                                        <Select.Option key={item.id} id={item.id}>
                                            {item.name}
                                        </Select.Option>
                                    ))}
                                </Select>
                                {productProposal.brand_state === ProductProposalsBrandStateEnum.EXISTS && (
                                    <p className={S.description}>
                                        {productProposal.brand_name_en} was entered as a new brand, but it already exists in the database. Use the existing one
                                        or correct the input if needed
                                    </p>
                                )}
                                {productProposal.brand_state === ProductProposalsBrandStateEnum.NOT_EXISTS && (
                                    <p className={S.description}>
                                        {productProposal.brand_name_en} is a new brand name. Create it or select an existing brand to continue
                                    </p>
                                )}
                            </>
                        )}
                    </div>

                    <div className={S.modal__actions}>
                        <Button color="brown" onClick={createPreventDefault(approve)}>
                            Save and approve
                        </Button>
                        <Button onClick={close}>Cancel</Button>
                    </div>
                </>
            )}
        </div>
    );
};
